var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(['1', '3'].includes(_vm.$store.state.currentUser.user.autorisation))?_c('Emargement'):_vm._e(),(['2', '3'].includes(_vm.$store.state.currentUser.user.autorisation))?_c('EmargementTrainer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }